module.exports = __webpack_public_path__ + "img/pr-2.2cae51c1.png";